<footer class="footer undefined undefined" id="footerBloc">
  <p class="clearfix text-muted m-0" style="text-align: center;">
    <span>Copyright  &copy; {{currentYear}} &nbsp;</span>
    <a href="#" id="pixinventLink"><b class="secondary">Thalasso n°1</b></a>
    <span class="d-none d-sm-inline-block">, All rights reserved.</span></p>
</footer>
<button class="btn btn-primary scroll-top" type="button"><i class="ft-arrow-up"></i></button>
